/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealizedDimensionLine } from './RealizedDimensionLine';
import {
    RealizedDimensionLineFromJSON,
    RealizedDimensionLineFromJSONTyped,
    RealizedDimensionLineToJSON,
    RealizedDimensionLineToJSONTyped,
} from './RealizedDimensionLine';

/**
 * 
 * @export
 * @interface RealizePlanContributionsResultDto
 */
export interface RealizePlanContributionsResultDto {
    /**
     * 
     * @type {string}
     * @memberof RealizePlanContributionsResultDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizePlanContributionsResultDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizePlanContributionsResultDto
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RealizePlanContributionsResultDto
     */
    anyScoreAdvanced?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RealizePlanContributionsResultDto
     */
    anySkipped?: boolean;
    /**
     * 
     * @type {Array<RealizedDimensionLine>}
     * @memberof RealizePlanContributionsResultDto
     */
    results?: Array<RealizedDimensionLine>;
}

/**
 * Check if a given object implements the RealizePlanContributionsResultDto interface.
 */
export function instanceOfRealizePlanContributionsResultDto(value: object): value is RealizePlanContributionsResultDto {
    return true;
}

export function RealizePlanContributionsResultDtoFromJSON(json: any): RealizePlanContributionsResultDto {
    return RealizePlanContributionsResultDtoFromJSONTyped(json, false);
}

export function RealizePlanContributionsResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealizePlanContributionsResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'planId': json['planId'] == null ? undefined : json['planId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'anyScoreAdvanced': json['anyScoreAdvanced'] == null ? undefined : json['anyScoreAdvanced'],
        'anySkipped': json['anySkipped'] == null ? undefined : json['anySkipped'],
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(RealizedDimensionLineFromJSON)),
    };
}

export function RealizePlanContributionsResultDtoToJSON(json: any): RealizePlanContributionsResultDto {
    return RealizePlanContributionsResultDtoToJSONTyped(json, false);
}

export function RealizePlanContributionsResultDtoToJSONTyped(value?: RealizePlanContributionsResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planId': value['planId'],
        'initiativeId': value['initiativeId'],
        'capabilityDomain': value['capabilityDomain'],
        'anyScoreAdvanced': value['anyScoreAdvanced'],
        'anySkipped': value['anySkipped'],
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(RealizedDimensionLineToJSON)),
    };
}

